import { API_BASE_URL } from "../config/api";

/**
 * Download a CSV from an admin-protected endpoint.
 * Uses the raw Fetch API so the response blob is handled correctly.
 *
 * @param {string} path  - relative path, e.g. "/analytics/cdp-users-csv"
 * @param {string} filename - suggested download filename
 */
export async function downloadAdminCsv(path, filename) {
  const token = localStorage.getItem("adminToken");
  const res = await fetch(`${API_BASE_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    if (res.status === 401 || res.status === 403) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRole");
      window.location.href = "/admin/login";
    }
    throw new Error(`Download failed: ${res.status}`);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
